import { useMediaQuery } from '@/hooks/useMediaQuery'

/** Desktop: wide viewport with fine pointer (mouse). iPad landscape stays tablet. */
export function useIsDesktopViewport(): boolean {
  const isWide = useMediaQuery('(min-width: 1024px)')
  const isFinePointer = useMediaQuery('(pointer: fine)')
  return isWide && isFinePointer
}

export type OrientedLayoutMode =
  | 'desktop'
  | 'tablet-portrait'
  | 'tablet-landscape'
  | 'phone-portrait'
  | 'phone-landscape'

export function useOrientedLayoutMode(): OrientedLayoutMode {
  const isPhone = useMediaQuery('(max-width: 767px)')
  const isDesktop = useIsDesktopViewport()
  const isPortrait = useMediaQuery('(orientation: portrait)')

  if (isPhone) {
    return isPortrait ? 'phone-portrait' : 'phone-landscape'
  }

  if (!isDesktop) {
    return isPortrait ? 'tablet-portrait' : 'tablet-landscape'
  }

  return 'desktop'
}

export type AppNavMode = 'sidebar' | 'sidebar-compact' | 'bottom'

export function useAppNavMode(): AppNavMode {
  const isPhone = useMediaQuery('(max-width: 767px)')
  const isDesktop = useIsDesktopViewport()
  const isPortrait = useMediaQuery('(orientation: portrait)')

  if (isDesktop) return 'sidebar'
  if (isPhone) return 'bottom'
  return isPortrait ? 'bottom' : 'sidebar-compact'
}

export type CatalogLayoutMode = 'phone' | 'tablet-portrait' | 'tablet-landscape' | 'desktop'

export function useCatalogLayoutMode(): CatalogLayoutMode {
  const isPhone = useMediaQuery('(max-width: 767px)')
  const isDesktop = useIsDesktopViewport()
  const isPortrait = useMediaQuery('(orientation: portrait)')

  if (isDesktop) return 'desktop'
  if (isPhone) return 'phone'
  return isPortrait ? 'tablet-portrait' : 'tablet-landscape'
}
